import _ from 'lodash';
import { Dropdown, Icon, Label } from 'semantic-ui-react';
import { uniqueKey } from '../../../common/keys';
import { eventStatusIcon } from '../../../components/props/propsCreate';
import { gEnums } from '../../../enums/globalEnums';
import { listHelpers } from '../../../lists/lists';

const StatusLabels = (props) => {

  const { itemData, handleStatusChange } = props
  const { startDate, endDate, useClientLandingPage, eventStatusType, _itemKey } = itemData

  const label = (index, value, iconName, iconColor, fluid) => <Label key={uniqueKey('tl', 'sl', index)} fluid={fluid} >
    <Icon color={iconColor} name={iconName} />{value ? value : '---'}
  </Label>

  const buttonsStatus = () => <Dropdown
    placeholder='Event Status'
    fluid
    search
    selection
    size={'mini'}
    itemkey={_itemKey}
    value={eventStatusType}
    options={listHelpers.listList(gEnums.eventStatusTypes)}
    onChange={handleStatusChange}
  />

  const statusLabels = () => {
    const { color, name } = eventStatusIcon(itemData, null, true)
    const sls = [
      label(1, _.startCase(eventStatusType), name, color),
      label(2, useClientLandingPage ? 'Client' : 'Event', 'home', useClientLandingPage ? 'blue' : 'green'),
      label(3, startDate, 'calendar check outline', 'green'),
      label(4, endDate, 'calendar times outline', 'red'),
    ]
    return sls
  }

  return <div>
    <div className={'df-r2-c2'}>
      {statusLabels()}
      {handleStatusChange && buttonsStatus()}
    </div>
    <div style={{ padding: '1em', fontSize: '.8rem' }}>
      {_itemKey}
    </div>
  </div>
}

export default StatusLabels